<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

@if (contactInformation$ | async; as contactInformation) {
  <div class="text-contrast-medium">
    <p-heading size="lg" color="inherit">{{ 'signup.supportBox.headline' | translate }}</p-heading>
    <p-text class="text-lg mt-fluid-sm" color="inherit">{{ 'signup.supportBox.subline' | translate }}</p-text>
    <div>
      @if (contactInformation.telephoneNumber) {
        <p-link-pure
          class="mt-fluid-sm block"
          [icon]="'none'"
          [href]="telephoneLinkOut(contactInformation.telephoneNumber)"
          [aria]="{
            'aria-label': 'signup.supportBox.telephone.aria' | translate: { number: contactInformation.telephoneNumber },
          }"
        >
          <p-icon class="me-static-sm" name="phone" color="contrast-medium" aria-hidden="true"></p-icon>
          <span class="text-contrast-medium" dir="ltr">{{ contactInformation.telephoneNumber }}</span>
        </p-link-pure>
      }
      @if (contactInformation.email) {
        <p-link-pure
          class="mt-fluid-sm block"
          [icon]="'none'"
          [href]="contactEmailLinkOut(contactInformation.email)"
          [aria]="{
            'aria-label': 'signup.supportBox.email.aria' | translate: { email: contactInformation.email },
          }"
        >
          <p-icon class="me-static-sm" name="email" color="contrast-medium" aria-hidden="true"></p-icon>
          <span class="text-contrast-medium">{{ contactInformation.email }}</span>
        </p-link-pure>
      }
    </div>
  </div>
}
